const labels = {
  counsellorHeading: "Schedule Session",
  interviewHeading: "Schedule Interview",
  counsellorBtn: "New Session",
  selfAssessmentBtn: "New Interview",
  scheduleBtn: "Schedule",
  counsellorTable: "Counsellor Name",
  interviewTable: "Title",
  interviewTableSecond: "Interviewer’s Profile Title",
  SideBarHeading: "Career Counselling",
  RatingHeading: "Counsellor Rating",
};

export default labels;
